$(()=>{

 $(document).on('mouseout', function(e){ 
		var div = $("[data-submenu-parent]"); 
		if ( !div.is(e.target) 
		    && div.has(e.target).length === 0 ) { 
            console.log(4);
			//$('[data-submenu]').removeClass('active');
            $('[data-submenu-parent]').removeClass('is-open');
		}
  });
  $('[data-submenu-parent]').each(function(){
     
    $(this).find('[data-menu-handle]').removeAttr('data-menu-handle');
    if($(this).find('.navigation__submenu-trigger').length > 0){
      $(this).find('.navigation__submenu-trigger').addClass('point-none');
      $(this).addClass('btn-open-menu');
    }
  });
  
 $('.btn-open-menu').on('click',function(){
      
     
      if($(this).find('[data-submenu]').hasClass('active')){
        
        $('[data-submenu]').removeClass('active');
        $('.btn-open-menu').removeClass('is-open');
        $(this).removeClass('is-open');
        $(this).find('[data-submenu]').removeClass('active');
      }else{
         $('[data-submenu]').removeClass('active');
         $('.btn-open-menu').removeClass('is-open');
         $(this).addClass('is-open');
         $(this).find('[data-submenu]').addClass('active');
      }
  });
  var icons$1 = window.theme.icons;
  function productLightbox() {
  var lightboxImages = $(".lightbox-image", document);
  if (!lightboxImages.length) return;
  var productLightbox;
  import(flu.chunks.photoswipe).then(function (_ref) {
    var PhotoSwipeLightbox = _ref.PhotoSwipeLightbox,
        PhotoSwipe = _ref.PhotoSwipe;
    productLightbox = new PhotoSwipeLightbox({
      gallery: ".lightbox-media-container",
      children: ".lightbox-image",
      pswpModule: PhotoSwipe,
      mainClass: "pswp--product-lightbox",
      bgOpacity: 1,
      arrowPrevSVG: icons$1.chevron,
      arrowNextSVG: icons$1.chevron,
      closeSVG: icons$1.close,
      zoomSVG: icons$1.zoom
    });
    productLightbox.init(); // Hide nav ui elements if single image

    productLightbox.on("firstUpdate", function () {
      var _productLightbox = productLightbox,
          pswp = _productLightbox.pswp,
          options = _productLightbox.options;
      var productImageCount = options.dataSource.items.length;

      if (productImageCount === 1) {
        u$1(pswp.element, "pswp--is-single-image");
      }
    });
  });
}
  $('.product .lightbox-image').on('click',function(e){
    e.preventDefault();
   productLightbox();
  });
});